var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

const SvgShareIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .share-1 {\n        fill: #8ad58f;\n      }\n\n      .share-2 {\n        fill: #373737;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(0.233 0.387)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_320",
    "data-name": "Ellipse 320",
    className: "share-1",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-0.233 -0.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    className: "share-2",
    d: "M1021.08,14.3a.793.793,0,1,1,.812-.793A.8.8,0,0,1,1021.08,14.3Zm-9.744-5.552a.863.863,0,0,1-.812-.793.812.812,0,0,1,1.624,0A.8.8,0,0,1,1011.336,8.745Zm9.744-7.138a.758.758,0,0,1,.812.793.812.812,0,0,1-1.624,0A.8.8,0,0,1,1021.08,1.607Zm0,9.6a2.446,2.446,0,0,0-1.624.634l-5.765-3.252a1.321,1.321,0,0,0,.081-.555,1.321,1.321,0,0,0-.081-.555l5.765-3.252a2.3,2.3,0,0,0,1.624.634,2.365,2.365,0,0,0,2.436-2.379,2.437,2.437,0,0,0-4.872,0,1.321,1.321,0,0,0,.081.555l-5.765,3.252a2.3,2.3,0,0,0-1.624-.634,2.38,2.38,0,1,0,0,4.759,2.3,2.3,0,0,0,1.624-.634l5.765,3.331c0,.159-.081.317-.081.555a2.355,2.355,0,0,0,4.709,0A2.4,2.4,0,0,0,1021.08,11.2Z",
    transform: "translate(-1000.997 7.803)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShareIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ShareIcon.d4c8566d.svg";
export { ForwardRef as ReactComponent };